import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
  Show,
  SimpleShowLayout,
  required,
} from 'react-admin';

export const EvmMethodLabelList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="method_id" label="Method ID" />
      <TextField source="label" />
    </Datagrid>
  </List>
);

export const EvmMethodLabelEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="method_id" label="Method ID" validate={required()} fullWidth />
      <TextInput source="label" validate={required()} fullWidth />
    </SimpleForm>
  </Edit>
);

export const EvmMethodLabelCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="method_id" label="Method ID" validate={required()} fullWidth />
      <TextInput source="label" validate={required()} fullWidth />
    </SimpleForm>
  </Create>
);

export const EvmMethodLabelShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="method_id" label="Method ID" />
      <TextField source="label" />
    </SimpleShowLayout>
  </Show>
);
